/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubmitRouteImport } from './routes/submit'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as MyIdeasRouteImport } from './routes/my-ideas'
import { Route as MetaIdeasRouteImport } from './routes/meta-ideas'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MetaIdeasIdRouteImport } from './routes/meta-ideas_.$id'
import { Route as IdeasIdRouteImport } from './routes/ideas.$id'
import { Route as AdminUsersRouteImport } from './routes/admin.users'

const SubmitRoute = SubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const MyIdeasRoute = MyIdeasRouteImport.update({
  id: '/my-ideas',
  path: '/my-ideas',
  getParentRoute: () => rootRouteImport,
} as any)
const MetaIdeasRoute = MetaIdeasRouteImport.update({
  id: '/meta-ideas',
  path: '/meta-ideas',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MetaIdeasIdRoute = MetaIdeasIdRouteImport.update({
  id: '/meta-ideas_/$id',
  path: '/meta-ideas/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const IdeasIdRoute = IdeasIdRouteImport.update({
  id: '/ideas/$id',
  path: '/ideas/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/meta-ideas': typeof MetaIdeasRoute
  '/my-ideas': typeof MyIdeasRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/submit': typeof SubmitRoute
  '/admin/users': typeof AdminUsersRoute
  '/ideas/$id': typeof IdeasIdRoute
  '/meta-ideas/$id': typeof MetaIdeasIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/meta-ideas': typeof MetaIdeasRoute
  '/my-ideas': typeof MyIdeasRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/submit': typeof SubmitRoute
  '/admin/users': typeof AdminUsersRoute
  '/ideas/$id': typeof IdeasIdRoute
  '/meta-ideas/$id': typeof MetaIdeasIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/meta-ideas': typeof MetaIdeasRoute
  '/my-ideas': typeof MyIdeasRoute
  '/profile': typeof ProfileRoute
  '/search': typeof SearchRoute
  '/submit': typeof SubmitRoute
  '/admin/users': typeof AdminUsersRoute
  '/ideas/$id': typeof IdeasIdRoute
  '/meta-ideas_/$id': typeof MetaIdeasIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/inbox'
    | '/login'
    | '/meta-ideas'
    | '/my-ideas'
    | '/profile'
    | '/search'
    | '/submit'
    | '/admin/users'
    | '/ideas/$id'
    | '/meta-ideas/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/inbox'
    | '/login'
    | '/meta-ideas'
    | '/my-ideas'
    | '/profile'
    | '/search'
    | '/submit'
    | '/admin/users'
    | '/ideas/$id'
    | '/meta-ideas/$id'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/inbox'
    | '/login'
    | '/meta-ideas'
    | '/my-ideas'
    | '/profile'
    | '/search'
    | '/submit'
    | '/admin/users'
    | '/ideas/$id'
    | '/meta-ideas_/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  MetaIdeasRoute: typeof MetaIdeasRoute
  MyIdeasRoute: typeof MyIdeasRoute
  ProfileRoute: typeof ProfileRoute
  SearchRoute: typeof SearchRoute
  SubmitRoute: typeof SubmitRoute
  AdminUsersRoute: typeof AdminUsersRoute
  IdeasIdRoute: typeof IdeasIdRoute
  MetaIdeasIdRoute: typeof MetaIdeasIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/submit': {
      id: '/submit'
      path: '/submit'
      fullPath: '/submit'
      preLoaderRoute: typeof SubmitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-ideas': {
      id: '/my-ideas'
      path: '/my-ideas'
      fullPath: '/my-ideas'
      preLoaderRoute: typeof MyIdeasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meta-ideas': {
      id: '/meta-ideas'
      path: '/meta-ideas'
      fullPath: '/meta-ideas'
      preLoaderRoute: typeof MetaIdeasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/meta-ideas_/$id': {
      id: '/meta-ideas_/$id'
      path: '/meta-ideas/$id'
      fullPath: '/meta-ideas/$id'
      preLoaderRoute: typeof MetaIdeasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ideas/$id': {
      id: '/ideas/$id'
      path: '/ideas/$id'
      fullPath: '/ideas/$id'
      preLoaderRoute: typeof IdeasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  MetaIdeasRoute: MetaIdeasRoute,
  MyIdeasRoute: MyIdeasRoute,
  ProfileRoute: ProfileRoute,
  SearchRoute: SearchRoute,
  SubmitRoute: SubmitRoute,
  AdminUsersRoute: AdminUsersRoute,
  IdeasIdRoute: IdeasIdRoute,
  MetaIdeasIdRoute: MetaIdeasIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
